import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// `perm` gates a menu item; items without `perm` are always shown.
const menu = [
  {
    title: 'Main',
    items: [
      { to: '/dashboard', icon: 'bi-speedometer2', label: 'Dashboard', perm: 'dashboard.view' },
    ],
  },
  {
    title: 'Management',
    items: [
      { to: '/vendors', icon: 'bi-people-fill', label: 'Vendors', perm: 'vendors.view' },
      { to: '/projects', icon: 'bi-briefcase-fill', label: 'Projects', perm: 'projects.view' },
      { to: '/hostings', icon: 'bi-hdd-network-fill', label: 'Hosting List', perm: 'hostings.view' },
      { to: '/proposals', icon: 'bi-file-earmark-ruled-fill', label: 'Proposals', perm: 'proposals.view' },
      { to: '/bills', icon: 'bi-file-earmark-text-fill', label: 'Invoices', perm: 'bills.view' },
      { to: '/payments', icon: 'bi-credit-card-2-front-fill', label: 'Payments', perm: 'payments.view' },
      { to: '/project-notes', icon: 'bi-journal-text', label: 'Project Notes', perm: 'project-notes.view' },
    ],
  },
  {
    title: 'Administration',
    items: [
      { to: '/users', icon: 'bi-person-badge-fill', label: 'Users', perm: 'users.view' },
      { to: '/roles', icon: 'bi-shield-lock-fill', label: 'Roles & Permissions', perm: 'roles.view' },
      { to: '/modules', icon: 'bi-grid-3x3-gap-fill', label: 'Modules', perm: 'modules.view' },
    ],
  },
  {
    title: 'Account',
    items: [
      { to: '/profile', icon: 'bi-person-circle', label: 'Profile' },
      { to: '/change-password', icon: 'bi-key-fill', label: 'Change Password' },
    ],
  },
  {
    title: 'Help',
    items: [
      { to: '/documentation', icon: 'bi-book-half', label: 'Documentation' },
    ],
  },
];

export default function Sidebar({ open }) {
  const { can } = useAuth();

  // Keep only items the user can see; drop sections that become empty.
  const visibleMenu = menu
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => !item.perm || can(item.perm)),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <aside className={`sidebar${open ? ' open' : ''}`}>
      <div className="sidebar-logo">
        <NavLink to="/dashboard" className="d-flex align-items-center">
          <span className="logo-icon">
            <i className="bi bi-receipt-cutoff text-white"></i>
          </span>
          <span className="ms-2 brand-name">BillFlow</span>
        </NavLink>
      </div>

      <nav className="sidebar-menu">
        {visibleMenu.map((section) => (
          <div key={section.title}>
            <div className="menu-title">{section.title}</div>
            {section.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `nav-item-link${isActive ? ' active' : ''}`}
              >
                <i className={`bi ${item.icon}`}></i>
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="p-3 border-top text-center" style={{ borderColor: 'rgba(255,255,255,.08)' }}>
        <small className="d-block" style={{ color: 'rgba(255,255,255,.35)', fontSize: '.7rem' }}>
          BillFlow v1.0 · © {new Date().getFullYear()}
        </small>
        <small className="d-block mt-1" style={{ color: 'rgba(255,255,255,.45)', fontSize: '.7rem' }}>
          Developed by{' '}
          <a
            href="https://gjdesigns.in"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#8ac640', textDecoration: 'none', fontWeight: 600 }}
          >
            GJDesigns
          </a>
        </small>
      </div>
    </aside>
  );
}
